import { SubmissionsGallery } from '@/components/submissions';
import { useDisplaySocket } from '@/hooks/useDisplaySocket';
import { useEventContext } from '@/pages/events/useEventContext';

/**
 * Event-level submissions tab: the full review surface (filters, gallery,
 * review drawer) across every challenge in the event. Mounts the event
 * socket so `submission:new` invalidations land while a facilitator is
 * parked here during a live event.
 */
export function EventSubmissionsTab() {
  const { event } = useEventContext();
  useDisplaySocket(event?.id);
  if (!event) return null;
  return <SubmissionsGallery eventId={event.id} />;
}
